import AppService from './AppService';

class LawnAnalyzerService extends AppService {
  constructor() {
    super();
    this.path = this.getPath('lawn-analyzer');
  }

  async analyze(address) {
    return this.http.post(`${this.path}/analyze`, {
      address,
    }, { timeout: 90000 });
  }

  async propertyAnalysis(address, zip) {
    return this.http.post('/web/property-analysis', {
      address,
      zip,
    }, { timeout: 90000 });
  }
}

export default LawnAnalyzerService;
